import {Injectable} from '@angular/core';
import {ColNativeServiceApi} from "../col-native-api";
import {ApiLearningUnitTeacher, ApiLessonInstance, ApiPersonalProfile} from "../../../model/rest-model";
import {Observable} from "rxjs";
import {Constraints, Platform} from "../../../../constraints";
import {LogsService} from "../../../../utils/services/logs.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AndroidBridgeBase} from "../../../../mobile/api-services/bridge/android-bridge-base";

@Injectable({
  providedIn: 'root'
})
export class ColAndroidService implements ColNativeServiceApi{

  private apiEndpoint = Constraints.androidGenericInternalApiEndpoint;

  constructor(
    private logger: LogsService,
    private http: HttpClient,
    private bridgeBase: AndroidBridgeBase
  ) {}

  private static buildRequestIdHeader(id: number){
    return new HttpHeaders({"X-Request-Id" : id.toString()});
  }

  private nextRequestIdHeader(){
    return ColAndroidService.buildRequestIdHeader(this.bridgeBase.getNextRequestId());
  }

  private getUrlLessonTeacher(path: string, teacherId?: number) {
    return `${this.apiEndpoint}/platform/${Platform.Lessons}/teacher` +
      (teacherId ? `/${teacherId}` : '') +
      path
  }

  createVideoClassroom(teacherId: number, lessonId: number): Observable<ApiLessonInstance<ApiPersonalProfile, ApiLearningUnitTeacher>> {
    this.logger.log(`creating video classroom with lessonId=${lessonId}`)
    return this.http.put<ApiLessonInstance<ApiPersonalProfile, ApiLearningUnitTeacher>>(
      this.getUrlLessonTeacher(`/lessons/${lessonId}/classroom`, teacherId), {}, {
        headers: this.nextRequestIdHeader()
      })
  }


}
